import React from 'react';
import styles from './SectionBadge.module.scss';

const SectionBadge = ({ children, icon }) => {
  return (
    <div className={styles.badge}>
      {icon && <span className={styles.icon}>{icon}</span>}
      <span className={styles.text}>{children}</span>
    </div>
  );
};

export default SectionBadge;
